import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// eslint-disable-next-line @typescript-eslint/unbound-method -- recommended by Chakra-UI
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);

// default base style from the Checkbox theme
const baseStyle = definePartsStyle({
  label: {},
  control: {},
  icon: {},
  container: {},
});

const primary = definePartsStyle({
  label: {},
  control: {
    bgColor: 'darkerOffGray',
    borderRadius: '4px',
    borderWidth: '1px',
    borderColor: 'primaryBlack',
    _hover: {
      borderColor: 'primaryBlack',
    },
    _indeterminate: {
      bgColor: 'primaryBlack',
      borderColor: 'primaryBlack',
      _hover: {
        bgColor: 'primaryBlack',
        borderColor: 'primaryBlack',
      },
    },
    _checked: {
      bgColor: 'primaryBlack',
      borderColor: 'primaryBlack',
      _hover: {
        bgColor: 'primaryBlack',
        borderColor: 'primaryBlack',
      },
    },
  },
  icon: {
    color: 'white',
  },
  container: {},
});

const sizes = {
  xl: definePartsStyle({
    control: {
      w: '22px',
      h: '22px',
    },
    icon: {
      w: '12px',
      h: '12px',
    },
  }),
  lg: definePartsStyle({
    control: {
      w: '20px',
      h: '20px',
    },
    icon: {
      w: '10px',
      h: '10px',
    },
  }),
  md: definePartsStyle({
    control: {
      w: '18px',
      h: '18px',
    },
    icon: {
      w: '8px',
      h: '8px',
    },
  }),
};

const CheckboxTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    primary,
  },
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
  sizes,
});

export default CheckboxTheme;
